import React, { useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import PreviewDelegation from "../../Generics/PreviewDelegation";

const Accept_Privacy = ({ onClose }) => {
  const [canAccept, setCanAccept] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const onScroll = () => {
      if (canAccept) return;
      const isBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 20;
      if (isBottom) setCanAccept(true);
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [canAccept]);

  return (
    <Box
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: { xs: "80%", md: "90%" },
        maxWidth: "900px",
        height: "80vh",
        backgroundColor: "#fff",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Typography
        className="color-grey"
        sx={{
          textTransform: "initial",
          fontSize: { xs: "18px", sm: "22px" },
          mt: 1,
          mb: 1,
          fontWeight: "bold",
        }}
      >
        Privacy & Disclaimer
      </Typography>

      <div
        onClick={onClose}
        className="icon-modal-close"
        style={{
          position: "absolute",
          top: "35px",
          right: "30px",
          cursor: "pointer",
          zIndex: 10,
        }}
      />

      <div
        ref={scrollRef}
        style={{
          flex: 1,
          overflowY: "auto",
          border: "1px solid #ccc",
        }}
      >
        <PreviewDelegation
          fileUrl="/LEXIA_soll deleghe_Disclaimer e info privacy (Draft 26 03 2026).pdf"
          hideCheckbox
          fullSize
        />
      </div>
    </Box>
  );
};

export default Accept_Privacy;
